import { createSlice } from '@reduxjs/toolkit'
import { TermsState } from './types'

const initialState: TermsState = {
  termsSections: [],
}

export const termsSlice = createSlice({
  name: 'terms',
  initialState,
  reducers: {
    setTermsSections(state, action) {
      state.termsSections = action.payload
    },
    resetTerms() {
      return initialState
    },
  },
})

export const termsReducer = termsSlice.reducer
export const { setTermsSections, resetTerms } = termsSlice.actions
